import { Box, Container, Stack } from "@mui/material";
import ModernTrackRecordsSidebar from "./ModernTrackRecordsSidebar";
import ROAReportView from "./ROAReportView";
import CashflowsReportView from "./CashflowsReportView";

export function TrackRecordsContainer({
  appBusinessUnit,
  aggData,
  fieldData,
  searchType,
  setSearchType,
  isCashflow,
  sidebarCollapsed,
  setSidebarCollapsed
}) {

  return (
    <Container maxWidth={false} disableGutters sx={{height: "100%", overflow: "auto"}}>
      <Stack direction="row" sx={{ width: "100%", height: "100%" }}>
        {/* Sidebar */}
        <Box
          sx={{
            width: sidebarCollapsed ? "0px" : "260px",
            transition: "width 0.2s ease",
            flexShrink: 0,
            overflow: sidebarCollapsed ? "hidden" : "visible",
          }}
        >
          <ModernTrackRecordsSidebar
            searchType={searchType}
            setSearchType={setSearchType}
            collapsed={sidebarCollapsed}
            setCollapsed={setSidebarCollapsed}
          />
        </Box>

        {/* Mount both report roots so ROA vs Cashflows each keep filters + grid state when switching sidebar */}
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            overflow: "auto",
            display: isCashflow ? "none" : "flex",
            flexDirection: "column",
          }}
        >
          <ROAReportView
            appBusinessUnit={appBusinessUnit}
            aggData={aggData}
            fieldData={fieldData}
            isAdvanced={searchType === "advanced"}
            searchType={searchType}
            setSearchType={setSearchType}
          />
        </Box>
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            overflow: "auto",
            display: isCashflow ? "flex" : "none",
            flexDirection: "column",
          }}
        >
          <CashflowsReportView
            appBusinessUnit={appBusinessUnit}
            aggData={aggData}
            fieldData={fieldData}
            isAdvanced={searchType === "cs_advanced"}
            searchType={searchType}
            setSearchType={setSearchType}
          />
        </Box>
      </Stack>
    </Container>
  );
}
